<template>
  <div class="banner-box">
    <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide>
        <video autoplay="autoplay" name="media" data-autoplay loop muted>
          <source :src="bannervideo" type="video/mp4" />
        </video>

        <!-- <img src="../assets/images/banner_home_2023.jpg?1.2" style="width:100%;height:100%" alt=""> -->

        <!-- 春节 -->
        <!-- <img src="../assets/images/cj2024.jpg?1.2" style="width:100%;height:100%" alt=""> -->
      </swiper-slide>
      <!-- <div class="swiper-pagination"></div> -->
    </swiper>
  </div>
</template>
<script>
import config from "../../config/index";
export default {
  data() {
    return {
      bannervideo: "",
      activeIndex: "",
      swiperOption: {
        // pagination: {
        //   el: ".swiper-pagination",
        //   clickable: true, // 允许点击小圆点跳转
        // },
        autoplay: false,
        loop: true
      }
    };
  },
  methods: {},
  created() {},
  mounted() {
    this.bannervideo =
      (process.env.NODE_ENV === "production"
        ? ".." + config.build.assetsPublicPath
        : "../") + "static/banner1.mp4";
    // this.bannervideo =
    //   (process.env.NODE_ENV === 'production'
    //     ? '..' + config.build.assetsPublicPath
    //     : '../') + 'static/banner1.mp4'
  }
};
</script>

<style>
.homepage-video-wrap {
  height: 100vh;
  min-height: 410px;
  overflow: hidden;
  text-align: center;
  position: absolute;
  top: 0;
  background-size: 100% 100%;
}
.video-player {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  height: 100vh;
  min-height: 410px;
}
@media screen and (min-width: 1368px) {
  .homepage-video-wrap video {
    -o-object-fit: cover;
    object-fit: cover;
    -o-object-position: 50% 60%;
    object-position: 50% 60%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bannerView.vue